import { render, staticRenderFns } from "./CountryBreakdown.vue?vue&type=template&id=818667c0&scoped=true"
import script from "./CountryBreakdown.vue?vue&type=script&lang=js"
export * from "./CountryBreakdown.vue?vue&type=script&lang=js"
import style0 from "./CountryBreakdown.vue?vue&type=style&index=0&id=818667c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "818667c0",
  null
  
)

export default component.exports